import { useCountDown } from "@ac-expo/hooks";
import dayjs from "dayjs";
import { useMemo } from "react";
import { cn } from "../../../utils";

type CountdownBannerProps = {
  startDate: string;
  endDate: string;
};

export function CountdownBanner({ startDate, endDate }: CountdownBannerProps) {
  const startTime = useMemo(() => dayjs(startDate), [startDate]);
  const endTime = useMemo(() => dayjs(endDate), [endDate]);

  const { daysDiff, hoursDiff, minutesDiff, now } = useCountDown(startTime);

  if (!now) return null;

  const isBeforeStart = !startTime.isBefore(now);
  const isInProgress = startTime.isBefore(now) && !endTime.isBefore(now);
  const isFinished = endTime.isBefore(now);

  return (
    <div
      className={cn(
        "absolute bottom-0 z-10 flex h-fit flex-row justify-between gap-4 rounded-tl-lg py-2 pl-2 pr-4 text-white",
        "right-0 w-fit items-end justify-end",
      )}
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      {isBeforeStart && (
        <>
          {daysDiff > 0 && (
            <div className="flex size-fit flex-col items-center justify-center">
              <span className="text-3xl font-bold">{daysDiff}</span>
              <span>JOUR{daysDiff > 1 ? "S" : ""}</span>
            </div>
          )}
          {(hoursDiff > 0 || daysDiff > 0) && (
            <div className="flex size-fit flex-col items-center justify-center">
              <span className="text-3xl font-bold">{hoursDiff}</span>
              <span>HEURE{hoursDiff > 1 ? "S" : ""}</span>
            </div>
          )}
          {(minutesDiff > 0 || hoursDiff > 0 || daysDiff > 0) && (
            <div className="flex size-fit flex-col items-center justify-center">
              <span className="text-3xl font-semibold">{minutesDiff}</span>
              <span>MINUTE{minutesDiff > 1 ? "S" : ""}</span>
            </div>
          )}
        </>
      )}
      {isInProgress && (
        <div className="flex size-fit flex-col items-center justify-center">
          <span className="text-2xl font-semibold lg:text-3xl">EN COURS</span>
        </div>
      )}
      {isFinished && (
        <div className="flex size-fit flex-col items-center justify-center">
          <span className="text-2xl font-semibold lg:text-3xl">FINI</span>
        </div>
      )}
    </div>
  );
}
